import UpAudits from "../pages/upcoming-audits/UpAudits";
import StoreBrowserIn from "../pages/reports/store-browser/StoreBrowserIn";
import StoreBrowser from "../pages/reports/store-browser/StoreBrowser";
import StorePerformance from "../pages/reports/store-performance/StorePerformance";
import Login from "../pages/auth/Login";
import AI from "../pages/ai-insights/AI";
import NetPromoterScore from "../pages/reports/nps/NetPromoterScore";
import Proof from "../pages/reports/store-browser/Proof";
import { Navigate } from "react-router-dom";
import Footer from "../components/layout/Footer";
import Dashboard from "../pages/dashboard/Dashboard";
import ActionTrack from "../pages/action-track/ActionTrack";
import QuesPerformance from "../pages/reports/question-performance/QuesPerformance";
import Trends from "../pages/reports/store-browser/Trends";
import Report from "../pages/reports/store-browser/Report";
import StoreInsights from "../pages/ai-insights/StoreInsights";
import AuditBrowser from "../pages/reports/audit-browser/AuditBrowser";
import AuditReport from "../pages/reports/section-browser/audit-report/AuditReport";
import SectionBrowser from "../pages/reports/section-browser/SectionBrowser";

const routesConfig = [
  { path: "/login", element: <Login />, navbarVisible: false },
  { path: "/dashboard", element: <Dashboard />, navbarVisible: true },

  { path: "/auditBrowser", element: <AuditBrowser />, navbarVisible: true },
  { path: "/reportbrowser", element: <SectionBrowser />, navbarVisible: true },
  { path: "/auditReport/:auditStoreId", element: <AuditReport />, navbarVisible: true },

  { path: "/actiontrack-report", element: <ActionTrack />, navbarVisible: true },
  { path: "/up-coming-audits", element: <UpAudits />, navbarVisible: true },
  { path: "/storebrowser", element: <StoreBrowser />, navbarVisible: true },
  {
    path: "/storeBrowserInsights/:storeId",
    element: <StoreBrowserIn />,
    navbarVisible: true,
    children: [
      { path: "trends", element: <Trends /> },
      { path: "reports", element: <Report /> },
      { path: "proof_comparison", element: <Proof /> },
      { index: true, element: <Navigate to="trends" replace /> },
    ],
  },
  { path: "/store-performance", element: <StorePerformance />, navbarVisible: true },
  { path: "/ai-overall-report-analysis", element: <AI />, navbarVisible: true },
  { path: "/net-promoter-score", element: <NetPromoterScore />, navbarVisible: true },
  { path: "/question-performance", element: <QuesPerformance />, navbarVisible: true },
  { path: "/ai-keyword-analysis", element: <StoreInsights />, navbarVisible: true },
  { path: "/footer", element: <Footer />, navbarVisible: true },
];

export default routesConfig;
